<template>
  <svg width="35" height="23" viewBox="0 0 35 23" fill="none" xmlns="http://www.w3.org/2000/svg" :class="className">
    <path
      d="M24.9503 11.8281C25.7934 11.8281 26.6175 11.5956 27.3185 11.16C28.0195 10.7243 28.5659 10.1051 28.8885 9.38066C29.2112 8.6562 29.2956 7.85903 29.1311 7.08995C28.9666 6.32087 28.5607 5.61442 27.9645 5.05995C27.3683 4.50547 26.6088 4.12787 25.7819 3.97489C24.955 3.82191 24.0979 3.90042 23.319 4.2005C22.5401 4.50058 21.8743 5.00875 21.4059 5.66075C20.9375 6.31274 20.6875 7.07928 20.6875 7.86343C20.6858 8.38452 20.7949 8.90078 21.0085 9.38251C21.2222 9.86424 21.5361 10.3019 21.9323 10.6704C22.3284 11.0389 22.799 11.3308 23.317 11.5295C23.8349 11.7282 24.39 11.8297 24.9503 11.8281ZM12.1667 10.2426C13.1781 10.2423 14.1667 9.96307 15.0075 9.44028C15.8483 8.91748 16.5036 8.17456 16.8905 7.30543C17.2774 6.43631 17.3786 5.48 17.1812 4.55742C16.9838 3.63483 16.4967 2.78739 15.7816 2.12223C15.0664 1.45708 14.1552 1.00407 13.1633 0.820479C12.1714 0.63689 11.1432 0.730965 10.2087 1.09081C9.27424 1.45065 8.47547 2.06011 7.91337 2.84213C7.35128 3.62415 7.0511 4.54362 7.05078 5.4843C7.04783 6.10993 7.17814 6.72991 7.43419 7.30845C7.69025 7.88699 8.06697 8.41263 8.54262 8.85502C9.01827 9.29741 9.58343 9.6478 10.2055 9.88595C10.8275 10.1241 11.4941 10.2453 12.1667 10.2426ZM24.9503 14.9993C21.8309 14.9993 15.5731 16.4588 15.5731 19.3601V22.9273H34.3274V19.3601C34.3306 16.4574 28.0728 14.9993 24.9503 14.9993ZM12.1667 13.4137C8.19422 13.4137 0.231628 15.2633 0.231628 18.9641V22.9288H12.1667V19.3601C12.2136 18.1817 12.618 17.0397 13.333 16.066C14.0481 15.0923 15.0448 14.3265 16.2078 13.8572C14.8795 13.5877 13.5261 13.4392 12.1667 13.4137Z"
      fill="#2D421E"
      :class="containerClass"
    />
  </svg>
</template>

<script>
export default {
  props: {
    className: {
      type:  [String, Array],
      default: "",
    },
    containerClass: {
      type: String,
      default: "",
    },
  },
};
</script>
